import { numberToHsv } from "./colors";
import { hsvToRgb } from "./colors";
import { rgbToHex } from "./colors";
import ReactGA from 'react-ga4';

ReactGA.initialize('G-7HQ6K7SGK5'); //primal nus latest -GA

const math = require('mathjs'); //install using "npm install mathjs"

// Fill objects based on data.state and data.goals



export function fillObjects(data, ctx, canvas) {
    let drawObstacle = new obstacle();
    drawObstacle.fill(data, ctx, canvas);
  }
  
  class obstacle {

    fill(data,ctx, canvas) {

      // console.log("data.state: " + data.state);

      for (let r = 0; r < data.size; r++) {

        let y = (data.height/data.size)*r;
        let color_depth = 30;

        for (let c = 0; c < data.size; c++) {

          let x = (data.height/data.size)*c;
          let rc_dataState = math.subset(data.state, math.index(r, c));  // data.state[r,c]
          let rc_dataGoals = math.subset(data.goals, math.index(r, c));  // data.goals[r,c]

          // Obstacle
          if (rc_dataState === -1) {
            // console.log("filling obstacle...")
            ctx.fillStyle = 'grey'; // Light Grey
            ctx.fillRect(x, y, canvas.width/data.size, canvas.height/data.size);
            
          }
          // Agent
          if (rc_dataState > 0) {
            const num = rc_dataState;
            const hsv = numberToHsv(num);
            const rgb = hsvToRgb(hsv);
            const hex = rgbToHex(rgb.r, rgb.g, rgb.b);
            //console.log(" rc_dataState : " + rc_dataState + "  hex : " + hex)
            ctx.fillStyle = "#" + hex;
            ctx.fillRect(x, y, canvas.width/data.size, canvas.height/data.size);

            // Confidence value - Not so important now!
            //confidence=data.blocking_confidences[rc_dataState-1]
            let confidence = math.subset(data.blocking_confidences, math.index(rc_dataState-1))
            confidence="%.0001f"%confidence
            ctx.fillStyle = 'black';
            ctx.font = "Arial 30 bold";
            //ctx.fillText(confidence, x+data.width/data.size/2, y+data.height/data.size/2)

          }

          // Goal
          if (rc_dataGoals > 0) {
            const num = rc_dataGoals;
            const hsv = numberToHsv(num);
            const rgb = hsvToRgb(hsv);
            const hex = rgbToHex(rgb.r, rgb.g, rgb.b);
            //console.log(" rc_dataState : " + rc_dataState + "  hex : " + hex)

            // Confidence value - Not so important now!
            if (rc_dataState == rc_dataGoals) {
              ctx.fillStyle = 'black';
            } else {
              ctx.fillStyle = "#" + hex;
            }
            const textSize = 20;
            ctx.font = "bold 20px Arial";
            const text = "+";
            const textWidth = ctx.measureText(text).width;
            ctx.fillText(text, x + (data.width / data.size / 2) - (textWidth / 2), y + (data.height / data.size / 2) + (textSize / 2)-3); 

          }
        }
      }   
    }
  }